import { Edit, Eye, Search, Trash2, ChevronLeft, ChevronRight, X, ChevronDown } from 'lucide-react';
import React, { useState, useEffect, useRef } from 'react'
import Pagination from '../../base_component/Pagination/Pagination';
import FormSelect from '../../base_component/FormSelect/FormSelect';
import Table from '../../base_component/Table/Table';
import plusIcon from "../../assets/images/Group 2117595477.svg"
import Dialog from '../../base_component/Dialog/Dialog';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomSelectStatus from '../../base_component/CustomSelectStatus/CustomSelectStatus';
import EllipsisLoader from '../../base_component/EllipsisLoader/EllipsisLoader';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { BsInfoCircleFill } from "react-icons/bs";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import ImageCropModal from '../../components/ImageCropModal';
import { artworkListAPI, createArtworkAPI, deleteArtworkAPI, editArtworkAPI, getMediumsAPI } from '../../service/ApiServices';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useDebounce } from 'use-debounce';
import { validateUrl } from '../../base_component/Common/data';

const TableSkeleton = () => (
    <div className="overflow-auto text-sm intro-y h-fit scroll 2xl:overflow-visible">
        <Table>
            <Table.Thead>
                <Table.Tr className="shadow-sm text-[#667085] py-4">
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium h-[50px]">
                        NO.
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        IMAGE
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        NAME
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        YEAR
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        MEDIUM
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        DESCRIPTION
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                        SIZE
                    </Table.Th>
                    <Table.Th className="border-b-0 whitespace-nowrap font-medium text-center">
                        ACTIONS
                    </Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
                {[...Array(10)].map((_, index) => (
                    <Table.Tr key={index} className="text-[#4B4B4B]">
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={20} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={38} height={38} borderRadius={8} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={120} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={40} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={80} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={200} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <Skeleton width={60} height={20} />
                        </Table.Td>
                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                            <div className="flex items-center justify-center gap-2">
                                <Skeleton width={20} height={20} circle />
                                <Skeleton width={20} height={20} circle />
                                <Skeleton width={20} height={20} circle />
                            </div>
                        </Table.Td>
                    </Table.Tr>
                ))}
            </Table.Tbody>
        </Table>
    </div>
);

export default function ArtworkList() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loaders, setLoaders] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [limitOption, setLimitOption] = useState(10);
    const [viewModal, setViewModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [artWorkDelete, setArtworkDelete] = useState(false)
    const [artworkToDelete, setArtworkToDelete] = useState(null)
    const [imagePreview, setImagePreview] = useState(null);
    const [addArtwork, setAddArtwork] = useState(false)
    const [showCropModal, setShowCropModal] = useState(false);
    const [tempImageFile, setTempImageFile] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editingArtwork, setEditingArtwork] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [yearFilter, setYearFilter] = useState('');
    const [mediumFilter, setMediumFilter] = useState(null);
    const [mediums, setMediums] = useState([]);
    const [yearDropdownOpen, setYearDropdownOpen] = useState(false);
    const [mediumDropdownOpen, setMediumDropdownOpen] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const [imageLoadingStates, setImageLoadingStates] = useState({});
    const [search] = useDebounce(searchTerm, 1000);
    const navigate = useNavigate();
    const location = useLocation();
    const isFirstRun = useRef(true);

    useEffect(() => {
        if (location.state?.modal) {
            setAddArtwork(true);
        }
        if (location.state) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    const getMediums = () => {
        getMediumsAPI()
            .then((res) => {
                const list = res?.data?.data?.mediums || [];
                const formatted = list.map((item) => ({
                    label: (item?.name || "").trim(),
                    value: item?.id,
                }));
                setMediums(formatted);
            })
            .catch((err) => {
                let message = err?.response?.data?.message;

                if (typeof message === 'object' && message !== null) {
                    if (message.error && message.error.errors && Array.isArray(message.error.errors)) {
                        const validationErrors = message.error.errors.map(err => err.msg).join(', ');
                        message = `Validation errors: ${validationErrors}`;
                    } else if (message.message) {
                        message = message.message;
                    } else if (message.error) {
                        message = message.error;
                    } else {
                        message = JSON.stringify(message);
                    }
                }

                if (err?.response?.status === 401) {
                    localStorage.removeItem('hoast_token')
                    localStorage.removeItem('hoast_refresh_token')
                    navigate('/login');
                }
                const errorMessage = typeof message === 'string' ? message : "Something went wrong!";
                toast.error(errorMessage);
            })
    };

    useEffect(() => {
        getMediums();
    }, []);

    const getArtworks = (page, showLoader = true) => {
        if (showLoader) {
            setLoaders(true);
        }
        const params = {
            page: page,
            limit: limitOption,
        }
        if (search) {
            params.search = search;
        }
        if (yearFilter) {
            params.years = yearFilter;
        }
        if (mediumFilter) {
            params.mediums = mediumFilter?.value;
        }
        artworkListAPI(params)
            .then((res) => {
                if (res?.data?.status === 1) {
                    const artworks = res.data.data.artworks || [];
                    setData(artworks);
                    setFilteredData(artworks);
                    setPageCount(res.data.total_pages || 1);
                    setLoaders(false);
                } else {
                    toast.error(res?.data?.message || 'Failed to fetch artworks');
                    setLoaders(false);
                }
            })
            .catch((err) => {
                setLoaders(false);
                let message = err?.response?.data?.message || 'Failed to fetch artworks';
                toast.error(message);
                if (err?.response?.status === 401) {
                    localStorage.removeItem('hoast_token')
                    localStorage.removeItem('hoast_refresh_token')
                    navigate('/login');
                }
            })
    }

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            getArtworks(pageNo, true);
        } else {
            getArtworks(pageNo, false);
        }
    }, [pageNo, limitOption, search, yearFilter, mediumFilter]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const yearDropdown = document.getElementById('year-dropdown');
            const mediumDropdown = document.getElementById('medium-dropdown');

            const isOutsideYear = yearDropdown && !yearDropdown.contains(event.target);
            const isOutsideMedium = mediumDropdown && !mediumDropdown.contains(event.target);

            if (isOutsideYear && isOutsideMedium) {
                setYearDropdownOpen(false);
                setMediumDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (filteredData && filteredData.length > 0) {
            const newLoadingStates = {};
            filteredData.forEach((item) => {
                if (item?.art_images[0]?.url && !(item.art_images[0].url in imageLoadingStates)) {
                    newLoadingStates[item.art_images[0].url] = true;
                }
            });
            if (Object.keys(newLoadingStates).length > 0) {
                setImageLoadingStates(prev => ({
                    ...prev,
                    ...newLoadingStates
                }));
            }
        }
    }, [filteredData]);

    const getUniqueYears = () => {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = currentYear; year >= currentYear - 50; year--) {
            years.push(year.toString());
        }

        return years;
    };

    const handleViewPage = (item) => {
        setViewModal(true)
        setSelectedItem(item);
    };

    const handleEditClick = (item) => {
        setIsEditing(true);
        setEditingArtwork(item);
        setAddArtwork(true);
        setTempImageFile(null);
        if (item?.art_images[0]?.url) {
            setImagePreview(validateUrl(item?.art_images[0]?.url));
        }
    };

    const handleDeleteClick = (item) => {
        setArtworkToDelete(item);
        setArtworkDelete(true);
    };

    const handleImageLoad = (imageUrl) => {
        setImageLoadingStates(prev => ({
            ...prev,
            [imageUrl]: false
        }));
    };

    const handleImageError = (imageUrl) => {
        setImageLoadingStates(prev => ({
            ...prev,
            [imageUrl]: false
        }));
    };

    const setImageLoading = (imageUrl) => {
        setImageLoadingStates(prev => ({
            ...prev,
            [imageUrl]: true
        }));
    };

    const getImageLoadingState = (imageUrl) => {
        return imageLoadingStates[imageUrl] !== false;
    };

    const handleConfirmDelete = async () => {
        setIsDeleteLoading(true);

        await new Promise(resolve => setTimeout(resolve, 1000));

        deleteArtworkAPI({ art_id: artworkToDelete.art_id })
            .then((res) => {
                const isLastItemOnPage = data?.length === 1 && pageNo > 1;
                const newPageNo = isLastItemOnPage ? pageNo - 1 : pageNo;
                toast.success(res?.data?.message);
                getArtworks(newPageNo, false);
                setArtworkDelete(false);
                setArtworkToDelete(null);
                setIsDeleteLoading(false);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                if (err?.response?.status === 401) {
                    localStorage.removeItem('hoast_token')
                    localStorage.removeItem('hoast_refresh_token')
                    navigate('/login');
                }
                setIsDeleteLoading(false);
            })

    };

    const handleCancelDelete = () => {
        setArtworkDelete(false);
        setArtworkToDelete(null);
    };

    const handlePageChange = (newPage) => {
        setPageNo(newPage);
    };

    const handleYearFilterChange = (value) => {
        setYearFilter(value);
        setPageNo(1);
    };

    const handleMediumFilterChange = (value) => {
        setMediumFilter(mediums.find(medium => medium.value === value));
        setPageNo(1);
    };

    const handleLimitChange = (value) => {
        setLimitOption(value);
        setPageNo(1);
    };

    const renderPaginationButtons = () => {
        const buttons = [];
        for (let i = 1; i <= pageCount; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`rounded-full h-9 w-9 font-bold text-base box border border-[#EDEDED] mx-1 ${pageNo === i ? 'bg-[#050840] text-white' : ''
                        }`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setPageNo(1);
    };

    const getInitialValues = () => {
        if (isEditing && editingArtwork) {
            return {
                name: editingArtwork.art_name || "",
                year: editingArtwork.art_year || "",
                medium: editingArtwork.medium_id || "",
                height: editingArtwork.art_height || "",
                width: editingArtwork.art_width || "",
                image: null,
                description: editingArtwork.art_description || "",
            };
        }

        return {
            name: "",
            year: "",
            medium: "",
            height: "",
            width: "",
            image: null,
            description: "",
        };
    };

    const validationSchema = Yup.object({
        name: Yup.string()
            .required("Name is required")
            .max(100, "Name must be at most 100 characters"),

        year: Yup.string().required("Year is required"),
        medium: Yup.string().required("Medium is required"),
        height: Yup.number()
            .positive("Must be positive")
            .required("Height is required"),

        width: Yup.number()
            .positive("Must be positive")
            .required("Width is required"),

        image: Yup.mixed().test("image-required", "Image is required", function (value) {
            if (isEditing && imagePreview) {
                return true;
            }
            const hasValidFile = tempImageFile && tempImageFile instanceof File;
            const hasImagePreview = !isEditing && imagePreview;
            return hasValidFile || hasImagePreview;
        }).nullable(),
        description: Yup.string().required("Description is required").max(150, "Maximum 150 words allowed"),
    });

    const handleImageChange = (event, setFieldValue) => {
        const file = event.currentTarget.files?.[0];
        if (file) {
            setTempImageFile(file);
            setShowCropModal(true);
        }
    };

    const handleCropComplete = (croppedImageUrl, croppedImageBlob) => {
        setImagePreview(croppedImageUrl);
        const croppedFile = new File([croppedImageBlob], 'cropped-image.jpg', { type: 'image/jpeg' });
        setCroppedImage(croppedFile);
        setShowCropModal(false);
    };

    const handleCropCancel = () => {
        setShowCropModal(false);
        setTempImageFile(null);
    };

    const handleSubmit = async (values) => {
        setIsSubmitLoading(true);

        await new Promise(resolve => setTimeout(resolve, 1500));

        if (isEditing) {
            const formData = new FormData();
            formData.append('art_id', editingArtwork.art_id);
            formData.append('art_name', values.name);
            formData.append('art_year', values.year);
            formData.append('medium_id', values.medium);
            formData.append('art_height', values.height);
            formData.append('art_width', values.width);
            formData.append('art_description', values.description);
            if (croppedImage) {
                formData.append('art_images', croppedImage);
            }

            editArtworkAPI(formData)
                .then((res) => {
                    if (res?.data?.status === 1) {
                        toast.success(res?.data?.message);
                        setAddArtwork(false);
                        getArtworks(pageNo, false);
                        setIsEditing(false);
                        setEditingArtwork(null);
                        setImagePreview(null);
                        setTempImageFile(null);
                        setIsSubmitLoading(false);
                        setCroppedImage(null)
                    } else {
                        toast.error(res?.data?.message);
                        setIsSubmitLoading(false);
                    }
                })
                .catch((err) => {
                    toast.error(err?.response?.data?.message);
                    if (err?.response?.status === 401) {
                        localStorage.removeItem('hoast_token')
                        localStorage.removeItem('hoast_refresh_token')
                        navigate('/login');
                    }
                    setIsSubmitLoading(false);
                })
        } else {
            const formData = new FormData();
            formData.append('art_name', values.name);
            formData.append('art_year', values.year);
            formData.append('medium_id', values.medium);
            formData.append('art_height', values.height);
            formData.append('art_width', values.width);
            formData.append('art_description', values.description);
            if (croppedImage) {
                formData.append('art_images', croppedImage);
            }

            createArtworkAPI(formData)
                .then((res) => {
                    if (res?.data?.status === 1) {
                        toast.success(res?.data?.message);
                        setAddArtwork(false);
                        getArtworks(pageNo, false);
                        setImagePreview(null);
                        setTempImageFile(null);
                        setIsSubmitLoading(false);
                    } else {
                        toast.error(res?.data?.message);
                        setIsSubmitLoading(false);
                    }
                })
                .catch((err) => {
                    toast.error(err?.response?.data?.message);
                    if (err?.response?.status === 401) {
                        localStorage.removeItem('hoast_token')
                        localStorage.removeItem('hoast_refresh_token')
                        navigate('/login');
                    }
                    setIsSubmitLoading(false);
                })
        }
    };

    const CustomDropdown = ({
        isOpen,
        onToggle,
        selectedValue,
        onSelect,
        options,
        placeholder,
        className = "",
        id = ""
    }) => {
        return (
            <div className={`relative ${className}`} id={id}>
                <button
                    onClick={onToggle}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white flex items-center justify-between"
                >
                    <span className={selectedValue ? "text-gray-900" : "text-gray-500"}>
                        {selectedValue || placeholder}
                    </span>
                    <ChevronDown
                        size={16}
                        className={`text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    />
                </button>

                {isOpen && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                        {options.map((option) => (
                            <button
                                key={option.value}
                                onClick={() => {
                                    onSelect(option.value);
                                    onToggle();
                                }}
                                className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors ${selectedValue === option.value ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                    }`}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className='bg-white rounded-xl'>
            <div className='p-5'>
                <div className='flex flex-col sm:flex-row border-b mb-5 pb-5 items-start sm:items-center justify-between gap-4'>
                    <div>
                        <p className='text-[#0F1113] text-[20px] sm:text-[24px] font-semibold mb-2'>Artwork</p>
                        <p className='text-[#667085] text-sm sm:text-base'>
                            All your artworks are listed here. Edit, remove, or showcase new pieces with ease.
                        </p>
                    </div>

                    <div className='flex justify-end w-full'>
                        <button
                            onClick={async () => {
                                setIsEditing(false);
                                setEditingArtwork(null);
                                setImagePreview(null);
                                setTempImageFile(null);
                                setAddArtwork(true);
                            }}
                            className='bg-[#F48B94] px-3 flex items-center justify-center gap-2 text-white p-2 pr-4 rounded-full disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            <img src={plusIcon} className='w-6 h-6 sm:w-8 sm:h-8' alt='' />
                            <span className="text-sm sm:text-base whitespace-nowrap">Add New</span>
                        </button>
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 flex-wrap">
                    <div className="w-full lg:w-[300px] flex items-center border rounded-lg p-3">
                        <Search size={20} className="text-[#7E7E7E]" />
                        <input
                            type="search"
                            placeholder="Search artworks..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="flex-1 outline-none border-none text-sm text-gray-800 px-2 bg-transparent"
                        />
                    </div>

                    <div className="w-full lg:w-auto flex flex-col sm:flex-row gap-4">
                        <div className="w-full sm:w-[200px]">
                            <CustomDropdown
                                isOpen={yearDropdownOpen}
                                onToggle={() => {
                                    setMediumDropdownOpen(false);
                                    setTimeout(() => {
                                        setYearDropdownOpen(!yearDropdownOpen);
                                    }, 0);
                                }}
                                selectedValue={yearFilter}
                                onSelect={handleYearFilterChange}
                                placeholder="Year"
                                options={[
                                    { value: "", label: "Years" },
                                    ...getUniqueYears().map((year) => ({
                                        value: year,
                                        label: year,
                                    })),
                                ]}
                                id="year-dropdown"
                            />
                        </div>

                        <div className="w-full sm:w-[200px]">
                            <CustomDropdown
                                isOpen={mediumDropdownOpen}
                                onToggle={() => {
                                    setYearDropdownOpen(false);
                                    setTimeout(() => {
                                        setMediumDropdownOpen(!mediumDropdownOpen);
                                    }, 0);
                                }}
                                selectedValue={mediumFilter?.label || ""}
                                onSelect={handleMediumFilterChange}
                                placeholder="Medium"
                                options={[
                                    { value: "", label: "Medium" },
                                    ...mediums,
                                ]}
                                id="medium-dropdown"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {loaders ? (
                <div className="h-[80vh]">
                    <TableSkeleton />
                </div>
            ) : (
                <div>
                    {filteredData.length > 0 ? (
                        <div className="col-span-12 pb-3 w-full">
                            <div className="overflow-auto text-sm intro-y h-fit scroll">
                                <Table>
                                    <Table.Thead>
                                        <Table.Tr className="shadow-sm text-[#667085] py-4">
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium h-[50px]">
                                                NO.
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                IMAGE
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                NAME
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                YEAR
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                MEDIUM
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                DESCRIPTION
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium">
                                                SIZE
                                            </Table.Th>
                                            <Table.Th className="border-b-0 whitespace-nowrap font-medium text-center">
                                                ACTIONS
                                            </Table.Th>
                                        </Table.Tr>
                                    </Table.Thead>

                                    <Table.Tbody>
                                        {filteredData &&
                                            filteredData.map((item, index) => {
                                                return (
                                                    <Table.Tr className="text-[#4B4B4B]" key={index}>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div>{item?.art_id}</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div className="relative w-[38px] h-[38px]">
                                                                {item?.art_images[0]?.url && getImageLoadingState(item.art_images[0].url) && (
                                                                    <Skeleton
                                                                        width={38}
                                                                        height={38}
                                                                        className="rounded-lg absolute top-0 left-0"
                                                                    />
                                                                )}
                                                                {item?.art_images[0]?.url && (
                                                                    <Zoom>
                                                                        <img
                                                                            src={validateUrl(item.art_images[0].url)}
                                                                            className='w-[38px] h-[38px] rounded-lg'
                                                                            alt=""
                                                                            onLoad={() => handleImageLoad(item.art_images[0].url)}
                                                                            onError={() => handleImageError(item.art_images[0].url)}
                                                                            onLoadStart={() => setImageLoading(item.art_images[0].url)}
                                                                            style={{
                                                                                display: getImageLoadingState(item.art_images[0].url) ? 'none' : 'block'
                                                                            }}
                                                                        />
                                                                    </Zoom>
                                                                )}
                                                            </div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div>{item?.art_name}</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div>{item?.art_year}</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div>{item?.medium_name}</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div className='w-48 truncate'>{item?.art_description}</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div>{item?.art_height}″ x {item?.art_width}″ Inches</div>
                                                        </Table.Td>
                                                        <Table.Td className="first:rounded-l-md last:rounded-r-md bg-white whitespace-nowrap">
                                                            <div className="flex items-center justify-center gap-2">
                                                                <button onClick={() => handleViewPage(item)} className="p-1 hover:bg-gray-100 text-[#899197] rounded">
                                                                    <Eye size={20} />
                                                                </button>
                                                                <button onClick={() => handleEditClick(item)} className="p-1 hover:bg-gray-100 text-[#899197] rounded">
                                                                    <Edit size={20} />
                                                                </button>
                                                                <button onClick={() => handleDeleteClick(item)} className="p-1 hover:bg-gray-100 text-[#899197] rounded">
                                                                    <Trash2 size={20} />
                                                                </button>
                                                            </div>
                                                        </Table.Td>
                                                    </Table.Tr>
                                                );
                                            })}
                                    </Table.Tbody>
                                </Table>
                            </div>

                            <div className="flex px-5 items-center col-span-12 justify-between my-3 gap-4">
                                <div className="flex items-center gap-4">
                                    <div>
                                        <FormSelect
                                            value={limitOption}
                                            onChange={(e) => handleLimitChange(e.target.value)}
                                            className="px-3 text-black bg-[#F8F8F8] outline-none"
                                        >
                                            <option value="10">Row 10</option>
                                            <option value="20">Row 20</option>
                                            <option value="30">Row 30</option>
                                            <option value="40">Row 40</option>
                                            <option value="50">Row 50</option>
                                        </FormSelect>
                                    </div>
                                </div>

                                <Pagination>
                                    <Pagination.Link>
                                        <button
                                            className='rounded-full p-1 font-bold text-base box border border-[#EDEDED]'
                                            onClick={handlePageChange.bind(null, pageNo - 1)}
                                            disabled={pageNo == 1}
                                        >
                                            <ChevronLeft />
                                        </button>
                                    </Pagination.Link>
                                    <div className="flex items-center">
                                        {renderPaginationButtons()}
                                    </div>
                                    <Pagination.Link>
                                        <button
                                            className='rounded-full p-1 font-bold text-base box border border-[#EDEDED]'
                                            onClick={handlePageChange.bind(null, pageNo + 1)}
                                            disabled={pageNo === pageCount}
                                        >
                                            <ChevronRight />
                                        </button>
                                    </Pagination.Link>
                                </Pagination>
                            </div>
                        </div>
                    ) : (
                        <div className="flex justify-center items-center text-center w-full h-[60vh] mt-8">
                            <p className="text-center text-base font-bold ">
                                {searchTerm || yearFilter || mediumFilter ? "No artworks found matching your filters" : "No Data Found"}
                            </p>
                        </div>
                    )}
                </div>
            )}

            <Dialog
                open={viewModal}
                size='xxl'
                onClose={() => setViewModal(false)}
            >
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                <div className="fixed inset-0 flex items-center justify-center p-2 sm:p-4">
                    <Dialog.Panel className="mx-4 max-w-4xl w-full bg-white rounded-xl shadow-lg p-3 sm:p-6 max-h-[90vh] overflow-y-auto">
                        <button
                            onClick={() => setViewModal(false)}
                            className="absolute cursor-pointer top-2 right-2 sm:top-3 sm:right-3 text-gray-400 hover:text-gray-600 z-10"
                        >
                            <span className="bg-gray-400 w-6 h-6 rounded-full flex items-center justify-center">
                                <X className="w-4 h-4 text-white" />
                            </span>
                        </button>
                        <div className='flex flex-col lg:flex-row items-start gap-3 sm:gap-5'>
                            <div className="w-full lg:w-1/2 lg:mt-0 mt-6 relative">
                                {selectedItem?.art_images[0]?.url && getImageLoadingState(selectedItem.art_images[0].url) && (
                                    <Skeleton
                                        width="100%"
                                        height={288}
                                        className="rounded-lg absolute top-0 left-0"
                                    />
                                )}
                                {selectedItem?.art_images[0]?.url && (
                                    <img
                                        src={validateUrl(selectedItem.art_images[0].url)}
                                        alt={selectedItem?.art_name}
                                        className="w-full h-48 sm:h-64 lg:h-72 rounded-lg object-cover"
                                        onLoad={() => handleImageLoad(selectedItem.art_images[0].url)}
                                        onError={() => handleImageError(selectedItem.art_images[0].url)}
                                        onLoadStart={() => setImageLoading(selectedItem.art_images[0].url)}
                                        style={{
                                            display: getImageLoadingState(selectedItem.art_images[0].url) ? 'none' : 'block'
                                        }}
                                    />
                                )}
                            </div>

                            <div className="w-full lg:w-1/2 mt-3 lg:mt-0 relative">
                                <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{selectedItem?.art_name}</h2>
                                <p className="text-xs sm:text-sm flex gap-2 items-center text-gray-500 mb-3 sm:mb-4">
                                    <BsInfoCircleFill className='text-[#F48B94] flex-shrink-0' />
                                    <span className="break-words">{selectedItem?.art_year} • {selectedItem?.medium_name} • {selectedItem?.art_height}″ x {selectedItem?.art_width}″ Inches</span>
                                </p>
                                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{selectedItem?.art_description}</p>
                            </div>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>

            <Dialog
                open={artWorkDelete}
                onClose={handleCancelDelete}
                size="md"
            >
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                <Dialog.Panel>
                    <div className='flex justify-end mt-3'>
                        <button
                            className="bg-[#F4F5FA] text-sm rounded-xl sm:mx-3 mx-2"
                            onClick={handleCancelDelete}
                        >
                            <X />
                        </button>
                    </div>

                    <Dialog.Description>
                        <div className="flex justify-center text-center md:px-8 px-2">
                            <div>
                                <h1 className="md:text-2xl text-xl font-semibold text-black">
                                    Delete This Artwork?
                                </h1>
                                <p className="md:text-base text-sm text-gray-500 my-3">
                                    This action will permanently remove the artwork from your profile. Are you sure you want to continue?
                                </p>
                                <div className="flex items-center my-8 justify-center">
                                    <button
                                        onClick={handleConfirmDelete}
                                        disabled={isDeleteLoading}
                                        className="bg-[#EA5F5F] h-[52px] w-full text-sm rounded-xl sm:mx-3 mx-2 text-white disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                    >
                                        {isDeleteLoading ? (
                                            <EllipsisLoader color="white" />
                                        ) : (
                                            "Yes, Delete"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>

            <Dialog
                open={addArtwork}
                onClose={() => {
                    if (!showCropModal) {
                        setAddArtwork(false);
                    }
                }}
                size="2xl">
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                <Dialog.Panel>
                    <div className="mx-auto text-sm p-4 sm:p-6 lg:p-8 max-h-[90vh] custom-scrollbar overflow-y-auto">
                        <div className="flex justify-between border-b pb-4 items-start mb-6">
                            <div className="flex-1">
                                <h2 className="text-lg sm:text-xl font-bold mb-2">
                                    {isEditing ? "Edit your Artwork" : "Add your Artwork"}
                                </h2>
                                <p className="text-gray-500 text-sm">
                                    {isEditing ? "Update your artwork details and make changes as needed." : "Showcase your talent by uploading your artwork. Make it visible to the world and grow your presence."}
                                </p>
                            </div>
                            <button
                                onClick={() => {
                                    setAddArtwork(false);
                                    setIsEditing(false);
                                    setEditingArtwork(null);
                                    setImagePreview(null);
                                }}
                                className="text-gray-400 hover:text-gray-600 transition-colors ml-4"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <Formik
                            initialValues={getInitialValues()}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                            validateOnMount={false}
                            validateOnChange={false}
                            validateOnBlur={true}
                        >
                            {({ setFieldValue, values }) => {
                                const isAllFieldsFilled = values.name && values.year && values.medium && values.height && values.width && (tempImageFile || imagePreview) && values.description;
                                const buttonColor = isAllFieldsFilled ? "#212121" : "#F0F1F3";

                                return (
                                    <Form className="space-y-6">
                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                                            <label className="lg:col-span-4 text-sm font-medium pt-2">Name</label>
                                            <div className="lg:col-span-8">
                                                <Field name="name">
                                                    {({ field, form, meta }) => (
                                                        <input
                                                            {...field}
                                                            type="text"
                                                            className={`w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"
                                                                }`}
                                                            placeholder="Enter artwork name"
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="name" component="div" className="text-red-500 text-xs mt-1" />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                                            <label className="lg:col-span-4 text-sm font-medium pt-2">Year & Medium</label>
                                            <div className="lg:col-span-8">
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                    <div>
                                                        <Field name="year">
                                                            {({ field, form, meta }) => (
                                                                <CustomSelectStatus
                                                                    name="year"
                                                                    value={field.value}
                                                                    onChange={(name, value) => {
                                                                        form.setFieldValue(name, value);
                                                                    }}
                                                                    options={getUniqueYears().map((year) => ({
                                                                        value: year,
                                                                        label: year,
                                                                    }))}
                                                                    error={meta.touched && meta.error}
                                                                    touched={meta.touched}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div>
                                                        <Field name="medium">
                                                            {({ field, form, meta }) => (
                                                                <CustomSelectStatus
                                                                    name="medium"
                                                                    value={field.value}
                                                                    onChange={(name, value) => {
                                                                        form.setFieldValue(name, value);
                                                                    }}
                                                                    options={mediums}
                                                                    error={meta.touched && meta.error}
                                                                    touched={meta.touched}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                                            <label className="lg:col-span-4 text-sm font-medium pt-2">Size (Inches)</label>
                                            <div className="lg:col-span-8">
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                    <div>
                                                        <Field name="height">
                                                            {({ field, form, meta }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className={`w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"
                                                                        }`}
                                                                    placeholder="Height"
                                                                    onKeyPress={(e) => {
                                                                        const charCode = e.which ? e.which : e.keyCode;
                                                                        if (
                                                                            charCode !== 46 &&
                                                                            charCode > 31 &&
                                                                            (charCode < 48 || charCode > 57)
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = value.split('.');

                                                                        if (parts.length > 2) {
                                                                            value = parts[0] + '.' + parts[1];
                                                                        }

                                                                        if (parts[1]?.length > 2) {
                                                                            value = parts[0] + '.' + parts[1].slice(0, 2);
                                                                        }

                                                                        form.setFieldValue('height', value);
                                                                    }}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="height" component="div" className="text-red-500 text-xs mt-1" />
                                                    </div>
                                                    <div>
                                                        <Field name="width">
                                                            {({ field, form, meta }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className={`w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"
                                                                        }`}
                                                                    placeholder="Width"
                                                                    onKeyPress={(e) => {
                                                                        const charCode = e.which ? e.which : e.keyCode;
                                                                        if (
                                                                            charCode !== 46 &&
                                                                            charCode > 31 &&
                                                                            (charCode < 48 || charCode > 57)
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = value.split('.');

                                                                        if (parts.length > 2) {
                                                                            value = parts[0] + '.' + parts[1];
                                                                        }

                                                                        if (parts[1]?.length > 2) {
                                                                            value = parts[0] + '.' + parts[1].slice(0, 2);
                                                                        }

                                                                        form.setFieldValue('width', value);
                                                                    }}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="width" component="div" className="text-red-500 text-xs mt-1" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                                            <label className="lg:col-span-4 text-sm font-medium pt-2">
                                                Image
                                                <div className="text-gray-400 text-xs mt-1">(recommended size: 1200 x 1200 px)</div>
                                            </label>
                                            <div className="lg:col-span-8">
                                                <Field name="image">
                                                    {({ field, form, meta }) => (
                                                        <div className={`border-2 border-dashed rounded-lg p-3 text-center transition-colors ${meta.touched && meta.error && !(isEditing && imagePreview) && !(!isEditing && imagePreview) && !tempImageFile ? "border-red-500" : "border-gray-300 hover:border-gray-400"
                                                            }`}>
                                                            <input
                                                                type="file"
                                                                accept=".png, .jpg, .jpeg, .svg"
                                                                onChange={(e) => handleImageChange(e, setFieldValue)}
                                                                onBlur={field.onBlur}
                                                                name={field.name}
                                                                className="hidden"
                                                                id="image-upload"
                                                            />
                                                            <label htmlFor="image-upload" className="cursor-pointer">
                                                                {imagePreview ? (
                                                                    <div className="space-y-4">
                                                                        <img src={imagePreview} alt="Preview" className="mx-auto h-24 w-24 object-cover rounded-lg" />
                                                                        <p className="text-sm text-gray-600">Click to change image</p>
                                                                    </div>
                                                                ) : (
                                                                    <div className="space-y-4">
                                                                        <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                                                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                        <div>
                                                                            <p className="text-sm text-gray-600">Click to upload</p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </label>
                                                        </div>
                                                    )}
                                                </Field>
                                                {!(isEditing && imagePreview) && !(!isEditing && imagePreview) && !tempImageFile && <ErrorMessage name="image" component="div" className="text-red-500 text-xs mt-1" />}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                                            <label className="lg:col-span-4 text-sm font-medium pt-2">
                                                Short description
                                                <div className="text-gray-400 text-xs mt-1">(You can write up to 150 characters)</div>
                                            </label>
                                            <div className="lg:col-span-8">
                                                <Field name="description">
                                                    {({ field, form, meta }) => (
                                                        <textarea
                                                            {...field}
                                                            className={`w-full border rounded-lg px-4 py-3 min-h-[100px] resize-none focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent resize-vertical ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"
                                                                }`}
                                                            placeholder="Enter description"
                                                        />
                                                    )}
                                                </Field>
                                                <div className="flex justify-between items-center mt-1">
                                                    <ErrorMessage name="description" component="div" className="text-red-500 text-xs whitespace-nowrap" />
                                                    <div className="text-xs text-gray-500 text-end w-full">
                                                        {values.description?.length || 0}/150
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='justify-end w-full flex'>
                                            <button
                                                type="submit"
                                                disabled={isSubmitLoading}
                                                style={{ backgroundColor: buttonColor }}
                                                className={`md:w-[200px] w-full h-[52px] py-3 rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${!isAllFieldsFilled ? 'text-black' : 'text-white'}`}
                                            >
                                                {isSubmitLoading ? (
                                                    <EllipsisLoader color="white" />
                                                ) : (
                                                    isEditing ? "Update" : "Add"
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </Dialog.Panel>
            </Dialog>

            <ImageCropModal
                isOpen={showCropModal}
                onClose={handleCropCancel}
                imageSrc={tempImageFile ? URL.createObjectURL(tempImageFile) : null}
                onCropComplete={handleCropComplete}
            />
        </div>
    );
}
